import { useProfile } from 'edrolo/domains/profile';
import ProfileNav from './ProfileNav';

const ConnectedProfileNav = () => {
  const { profile } = useProfile(!!'immutable');
  return <ProfileNav profile={profile} />;
};

export default ConnectedProfileNav;
